<template>
	<div class="wrap">
		<el-row class="tag color-orange" v-if="!showAll">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-circle-close"></i>
						未完成此患者的饮食评估，无法自动生成饮食处方，请前去完成评估
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<!-- <a @click="onEvalShow(sideEvalList)" class="goto">去评估</a> -->
					</el-col>
				</el-row>
		<template v-if="showAll">

			<div v-if="isShow">
				<el-row class="tag color-grey" v-if="tag && !hidden && !isSave">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-info"></i>
						已完成对患者的饮食评估，自动生成饮食处方，请医生确认后发布
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<a @click="isHidden" class="know">我知道了</a>
					</el-col>
				</el-row>
				
			</div>

			<el-form ref="form" :model="form" :rules="rules" label-width="80px">
				<div class="body" id="diet">
					<div class="item">
						<h2 class="cf">饮食处方</h2>
					</div>
					<div v-show="tag">
						<div class="item">
							<div class="title">
								评估结果
								<el-button class="exportPdf" v-if="!showSaveBtn" :loading="isLoading" @click="exportPdf">导出处方</el-button>

							</div>
							<el-row class="text">
								<el-col :span="12" v-show="form.energy == 1">
									<span>膳食能量：</span>
									<span class="level-middle">膳食能量不足</span>
								</el-col>
								<el-col :span="12" v-show="form.energy == 2">
									<span>膳食能量：</span>
									<span class="level-low">膳食能量合理</span>
								</el-col>
								<el-col :span="12" v-show="form.energy == 3">
									<span>膳食能量：</span>
									<span class="level-high">膳食能量超标</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 1">
									<span>膳食结构：</span>
									<span class="level-low">膳食结构较均衡</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 2">
									<span>膳食结构：</span>
									<span class="level-middle">膳食结构轻度不均衡</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 3">
									<span>膳食结构：</span>
									<span class="level-high">膳食结构明显不均衡</span>
								</el-col>
							</el-row>
						</div>
					</div>
					<div class="mTop10">
						<div class="title item">
							处方内容
						</div>
						<div v-show="!isSave">
							<div>
								<table class="table">
									<tr>
										<td class="topic">
											推荐每日摄入总热量：
										</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.calorieSum">
														<el-input v-model="form.content.calorieSum" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													Kcal
												</el-col>
											</el-row>
										</td>
										<td class="topic">
											每日总份数：
										</td>
										<td>
											{{form.content.totalCopies}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日油脂类摄入量：
										</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.oil">
														<el-input v-model="form.content.oil "/>
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td class="topic">
											每日食盐摄入量：
										</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.salt">
														<el-input v-model="form.content.salt" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													克
												</el-col>
											</el-row>
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日五谷根茎类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.grain==''?0:form.content.breakfast.grain)+
											parseFloat(form.content.lunch.grain==''?0:form.content.lunch.grain)+
											parseFloat(form.content.dinner.grain==''?0:form.content.dinner.grain)}}份
										</td>
										<td class="topic">
											每日蔬菜类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.vegetables==''?0:form.content.breakfast.vegetables)+
											parseFloat(form.content.lunch.vegetables==''?0:form.content.lunch.vegetables)+
											parseFloat(form.content.dinner.vegetables==''?0:form.content.dinner.vegetables)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日鱼肉蛋豆类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.fish==''?0:form.content.breakfast.fish)+
											parseFloat(form.content.lunch.fish==''?0:form.content.lunch.fish)+
											parseFloat(form.content.dinner.fish==''?0:form.content.dinner.fish)}}份
										</td>
										<td class="topic">
											每日奶类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.milk==''?0:form.content.breakfast.milk)+
											parseFloat(form.content.lunch.milk==''?0:form.content.lunch.milk)+
											parseFloat(form.content.dinner.milk==''?0:form.content.dinner.milk)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日水果类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.fruits==''?0:form.content.add.fruits)}}份
										</td>
										<td class="topic">
											每日坚果种子类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.nut==''?0:form.content.add.nut)}}份
										</td>
									</tr>
								</table>
							</div>
							<div style="margin: 20px 0;font-size: 20px;">
								<div class="sx"></div>每日早餐
							</div>
							<div>
								<table class="table">
									<thead>
										<th class="topic">食物类别</th>
										<th class="topic">推荐份数</th>
										<th class="topic">1份食物示例</th>
									</thead>
									<tr>
										<td class="topic">五谷根茎类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.breakfast.grain">
														<el-input v-model="form.content.breakfast.grain" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
										</td>
									</tr>
									<tr>
										<td class="topic">蔬菜类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0"
														prop="content.breakfast.vegetables">
														<el-input v-model="form.content.breakfast.vegetables" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
										</td>
									</tr>
									<tr>
										<td class="topic">蛋豆鱼肉类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.breakfast.fish">
														<el-input v-model="form.content.breakfast.fish" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
									</tr>
									<tr>
										<td class="topic">奶类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.breakfast.milk">
														<el-input v-model="form.content.breakfast.milk" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
									</tr>
								</table>
							</div>

							<div style="margin: 20px 0;font-size: 20px;">
								<div class="sx"></div>每日午餐
							</div>
							<div>
								<table class="table">
									<thead>
										<th class="topic">食物类别</th>
										<th class="topic">推荐份数</th>
										<th class="topic">1份食物示例</th>
									</thead>
									<tr>
										<td class="topic">五谷根茎类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.lunch.grain">
														<el-input v-model="form.content.lunch.grain" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
										</td>
									</tr>
									<tr>
										<td class="topic">蔬菜类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.lunch.vegetables">
														<el-input v-model="form.content.lunch.vegetables" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
										</td>
									</tr>
									<tr>
										<td class="topic">蛋豆鱼肉类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.lunch.fish">
														<el-input v-model="form.content.lunch.fish" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
									</tr>
									<tr>
										<td class="topic">奶类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.lunch.milk">
														<el-input v-model="form.content.lunch.milk" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
									</tr>
								</table>
							</div>

							<div style="margin: 20px 0;font-size: 20px;">
								<div class="sx"></div>每日晚餐
							</div>
							<div>
								<table class="table">
									<thead>
										<th class="topic">食物类别</th>
										<th class="topic">推荐份数</th>
										<th class="topic">1份食物示例</th>
									</thead>
									<tr>
										<td class="topic">五谷根茎类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.dinner.grain">
														<el-input v-model="form.content.dinner.grain" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
										</td>
									</tr>
									<tr>
										<td class="topic">蔬菜类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.dinner.vegetables">
														<el-input v-model="form.content.dinner.vegetables" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
										</td>
									</tr>
									<tr>
										<td class="topic">蛋豆鱼肉类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.dinner.fish">
														<el-input v-model="form.content.dinner.fish" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
									</tr>
									<tr>
										<td class="topic">奶类</td>
										<td>
											<el-row>
												<el-col :span="16" class="tag_text_right">
													<el-form-item label="" label-width="0" prop="content.dinner.milk">
														<el-input v-model="form.content.dinner.milk" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
									</tr>
								</table>
							</div>

							<div style="margin: 20px 0;font-size: 20px;">
								<div class="sx"></div>每日加餐
							</div>
							<div>
								<table class="table">
									<thead>
										<th class="topic">食物类别</th>
										<th class="topic">推荐份数</th>
										<th class="topic">1份食物示例</th>
									</thead>
									<tr>
										<td class="topic">水果类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.add.fruits">
														<el-input v-model="form.content.add.fruits" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>苹果、梨、桃、橘子、橙子、杏、狝猴桃切块或葡萄粒1碗；草莓1碗半、西瓜2碗；中等大小香蕉1根；纯果汁1杯（200ml)</td>
									</tr>
									<tr>
										<td class="topic">坚果种子类</td>
										<td>
											<el-row>
												<el-col :span="16" style="text-align: right;">
													<el-form-item label="" label-width="0" prop="content.add.nut">
														<el-input v-model="form.content.add.nut" />
													</el-form-item>
												</el-col>
												<el-col :span="8" class="text_dec">
													份
												</el-col>
											</el-row>
										</td>
										<td>坚果种子1汤勺（15克）；核桃2个；杏仁10粒</td>
									</tr>
								</table>
							</div>
						</div>

						<div v-show="isSave">
							<div class="item">
								<table class="table">
									<tr class="tr">
										<td class="topic">
											推荐每日摄入总热量：
										</td>
										<td>
											<el-row>
												{{form.content.calorieSum}} Kcal
											</el-row>
										</td>
										<td class="topic">
											每日总份数：
										</td>
										<td>
											{{form.content.totalCopies}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日油脂类摄入量：
										</td>
										<td>
											<el-row>
												{{form.content.oil}} 份
											</el-row>
										</td>
										<td class="topic">
											每日食盐摄入量：
										</td>
										<td>
											<el-row>
												{{form.content.salt}} 克
											</el-row>
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日五谷根茎类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.grain==''?0:form.content.breakfast.grain)+
												parseFloat(form.content.lunch.grain==''?0:form.content.lunch.grain)+
												parseFloat(form.content.dinner.grain==''?0:form.content.dinner.grain)}}份
										</td>
										<td class="topic">
											每日蔬菜类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.vegetables==''?0:form.content.breakfast.vegetables)+
												parseFloat(form.content.lunch.vegetables==''?0:form.content.lunch.vegetables)+
												parseFloat(form.content.dinner.vegetables==''?0:form.content.dinner.vegetables)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日鱼肉蛋豆类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.fish==''?0:form.content.breakfast.fish)+
												parseFloat(form.content.lunch.fish==''?0:form.content.lunch.fish)+
												parseFloat(form.content.dinner.fish==''?0:form.content.dinner.fish)}}份
										</td>
										<td class="topic">
											每日奶类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.milk==''?0:form.content.breakfast.milk)+
												parseFloat(form.content.lunch.milk==''?0:form.content.lunch.milk)+
												parseFloat(form.content.dinner.milk==''?0:form.content.dinner.milk)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日水果类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.fruits==''?0:form.content.add.fruits)}}份
										</td>
										<td class="topic">
											每日坚果种子类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.nut==''?0:form.content.add.nut)}}份
										</td>
									</tr>
								</table>
							</div>
							<div class="desc item">
								长期不合理的饮食习惯是导致各种慢性疾病的重要原因，个性化的膳食调理是预防疾病和促进健康的重要手段。合理的膳食原则一是要满足人体生命活动所需的营养供给；二是适合个体日常活动的能量需要。本膳食调养方案是依据个人的身高、体重、体力活动水平及疾病与健康情况并参照《2016年中国居民膳食指南》、《2015-2020年美国居民膳食指南》及目前国际上排名最前的DASH饮食模式和地中海饮食模式，个性化的计算并制定出每日饮食总热量和营养素的合理搭配方案。您只需在方案推荐的食物类别中选择喜欢吃的食物并按照方案推荐的份量进餐，就可有效改善您的健康状况。
							</div>
							<div class="item">
								<div class="m20">
									<div class="sx"></div>每日早餐
								</div>
								<div>
									<table class="table">
										<thead>
											<th class="topic">食物类别</th>
											<th class="topic">推荐份数</th>
											<th class="topic">1份食物示例</th>
										</thead>
										<tr>
											<td class="topic">五谷根茎类</td>
											<td>
												{{form.content.breakfast.grain}}份
											</td>
											<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
											</td>
										</tr>
										<tr>
											<td class="topic">蔬菜类</td>
											<td>
												{{form.content.breakfast.vegetables}}份
											</td>
											<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
											</td>
										</tr>
										<tr>
											<td class="topic">蛋豆鱼肉类</td>
											<td>
												{{form.content.breakfast.fish}}份
											</td>
											<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
										</tr>
										<tr>
											<td class="topic">奶类</td>
											<td>
												{{form.content.breakfast.milk}}份
											</td>
											<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
										</tr>
									</table>
								</div>
								<div class="m20">
									<div class="sx"></div>每日午餐
								</div>
								<div>
									<table class="table">
										<thead>
											<th class="topic">食物类别</th>
											<th class="topic">推荐份数</th>
											<th class="topic">1份食物示例</th>
										</thead>
										<tr>
											<td class="topic">五谷根茎类</td>
											<td>
												{{form.content.lunch.grain}}份
											</td>
											<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
											</td>
										</tr>
										<tr>
											<td class="topic">蔬菜类</td>
											<td>
												{{form.content.lunch.vegetables}}份
											</td>
											<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
											</td>
										</tr>
										<tr>
											<td class="topic">蛋豆鱼肉类</td>
											<td>
												{{form.content.lunch.fish}}份
											</td>
											<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
										</tr>
										<tr>
											<td class="topic">奶类</td>
											<td>
												{{form.content.lunch.milk}}份
											</td>
											<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
										</tr>
									</table>
								</div>
								<div class="m20">
									<div class="sx"></div>每日晚餐
								</div>
								<div>
									<table class="table">
										<thead>
											<th class="topic">食物类别</th>
											<th class="topic">推荐份数</th>
											<th class="topic">1份食物示例</th>
										</thead>
										<tr>
											<td class="topic">五谷根茎类</td>
											<td>
												{{form.content.dinner.grain}}份
											</td>
											<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
											</td>
										</tr>
										<tr>
											<td class="topic">蔬菜类</td>
											<td>
												{{form.content.dinner.vegetables}}份
											</td>
											<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
											</td>
										</tr>
										<tr>
											<td class="topic">蛋豆鱼肉类</td>
											<td>
												{{form.content.dinner.fish}}份
											</td>
											<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
										</tr>
										<tr>
											<td class="topic">奶类</td>
											<td>
												{{form.content.dinner.milk}}份
											</td>
											<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
										</tr>
									</table>
								</div>
								<div class="m20">
									<div class="sx"></div>每日加餐
								</div>
								<div>
									<table class="table">
										<thead>
											<th class="topic">食物类别</th>
											<th class="topic">推荐份数</th>
											<th class="topic">1份食物示例</th>
										</thead>
										<tr>
											<td class="topic">水果类</td>
											<td>
												{{form.content.add.fruits}}份
											</td>
											<td>苹果、梨、桃、橘子、橙子、杏、狝猴桃切块或葡萄粒1碗；草莓1碗半、西瓜2碗；中等大小香蕉1根；纯果汁1杯（200ml)</td>
										</tr>
										<tr>
											<td class="topic">坚果种子类</td>
											<td>
												{{form.content.add.nut}}份
											</td>
											<td>坚果种子1汤勺（15克）；核桃2个；杏仁10粒</td>
										</tr>
									</table>
								</div>
							</div>
							<div class="item">
								<div class="m20">
									<div class="sx"></div>健康饮食模式强调
								</div>
								<div class="desc">
									<li>
										膳食方案中推荐的五谷根茎类份量中至少应一半以上选择全谷物食物。全谷物食物是指完整、碾碎、破碎或压片的谷物种子，基本营养成分包括淀粉质胚乳、胚芽与麸皮，各组成部分的相对比例与完整果实一样。全谷物食品能够极大地增加膳食纤维、B族维生素及矿物质的营养供给，延缓血糖的上升速度，对控制血糖，预防心脑血管疾病有重要作用。
									</li>
									<li>
										尽可能选择高营养密度的食物和饮料，即能最大限度提供维生素、矿物质和其他人体所需的、对健康有益的营养素的食物，很少或几乎不添加固体脂肪或额外的糖、精炼的淀粉或钠。
									</li>
									<li>
										向食用更多蔬菜、水果的饮食模式转变；用全麦面包替换白面包、用糙米替换白米；用海产品替换肉禽蛋；用豆类或者坚果与种子的混合食物代替肉禽；用植物油替换固体脂肪；用水替换甜饮料以减少添加糖摄入；用脱/低脂奶、瘦肉替代全脂奶和肥肉以减少饱和脂肪的摄入；用香草和香料替换盐给食物调味；选择新鲜、冷冻食品替换加工肉类和家禽以减少盐的摄入。
									</li>
									<li>
										推荐成年人和年龄≥14岁的青少年每天限制钠盐摄入低于6g（患有高血压者低于5克）。
									</li>
								</div>
							</div>
						</div>
						<el-row class="dealwith">
						<el-col :span="12"  v-if="!showSaveBtn">
							责任医师：{{form.name}}<br/>
							发布时间：{{form.time}}
						</el-col>
						<!-- {{ prescriptionItem.hospitalFoodVO }} -->
						<el-col :span="12" class="tag_text_right" v-if="prescriptionItem.hospitalFoodVO?.pushTime">
							推送时间：{{prescriptionItem.hospitalFoodVO.pushTime}}
						</el-col>
					</el-row>
					</div>
					<div class="body hide" id="diet-print">
						<div class="item">
							<h2 class="cf">饮食处方</h2>
						</div>
						<div style="color: #333;font-weight: normal;margin:16px 0;text-align: center;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
						<div class="item" v-show="tag">
							<div class="title">
								评估结果
							</div>
							<el-row class="text">
								<el-col :span="12" v-show="form.energy == 1">
									<span>膳食能量：</span>
									<span class="level-middle">膳食能量不足</span>
								</el-col>
								<el-col :span="12" v-show="form.energy == 2">
									<span>膳食能量：</span>
									<span class="level-low">膳食能量合理</span>
								</el-col>
								<el-col :span="12" v-show="form.energy == 3">
									<span>膳食能量：</span>
									<span class="level-high">膳食能量超标</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 1">
									<span>膳食结构：</span>
									<span class="level-low">膳食结构较均衡</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 2">
									<span>膳食结构：</span>
									<span class="level-middle">膳食结构轻度不均衡</span>
								</el-col>
								<el-col :span="12" v-show="form.structure == 3">
									<span>膳食结构：</span>
									<span class="level-high">膳食结构明显不均衡</span>
								</el-col>
							</el-row>
						</div>
						<div class="m20">
							<div class="title item">
								处方内容
							</div>
							<div class="item">
								<table class="table">
									<tr class="tr">
										<td class="topic">
											推荐每日摄入总热量：
										</td>
										<td>
											<el-row>
												{{form.content.calorieSum}} Kcal
											</el-row>
										</td>
										<td class="topic">
											每日总份数：
										</td>
										<td>
											{{form.content.totalCopies}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日油脂类摄入量：
										</td>
										<td>
											<el-row>
												{{form.content.oil}} 份
											</el-row>
										</td>
										<td class="topic">
											每日食盐摄入量：
										</td>
										<td>
											<el-row>
												{{form.content.salt}} 克
											</el-row>
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日五谷根茎类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.grain==''?0:form.content.breakfast.grain)+
												parseFloat(form.content.lunch.grain==''?0:form.content.lunch.grain)+
												parseFloat(form.content.dinner.grain==''?0:form.content.dinner.grain)}}份
										</td>
										<td class="topic">
											每日蔬菜类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.vegetables==''?0:form.content.breakfast.vegetables)+
												parseFloat(form.content.lunch.vegetables==''?0:form.content.lunch.vegetables)+
												parseFloat(form.content.dinner.vegetables==''?0:form.content.dinner.vegetables)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日鱼肉蛋豆类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.fish==''?0:form.content.breakfast.fish)+
												parseFloat(form.content.lunch.fish==''?0:form.content.lunch.fish)+
												parseFloat(form.content.dinner.fish==''?0:form.content.dinner.fish)}}份
										</td>
										<td class="topic">
											每日奶类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.breakfast.milk==''?0:form.content.breakfast.milk)+
												parseFloat(form.content.lunch.milk==''?0:form.content.lunch.milk)+
												parseFloat(form.content.dinner.milk==''?0:form.content.dinner.milk)}}份
										</td>
									</tr>
									<tr>
										<td class="topic">
											每日水果类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.fruits==''?0:form.content.add.fruits)}}份
										</td>
										<td class="topic">
											每日坚果种子类摄入量：
										</td>
										<td>
											{{parseFloat(form.content.add.nut==''?0:form.content.add.nut)}}份
										</td>
									</tr>
								</table>
							</div>
							<div class="desc item">
								长期不合理的饮食习惯是导致各种慢性疾病的重要原因，个性化的膳食调理是预防疾病和促进健康的重要手段。合理的膳食原则一是要满足人体生命活动所需的营养供给；二是适合个体日常活动的能量需要。本膳食调养方案是依据个人的身高、体重、体力活动水平及疾病与健康情况并参照《2016年中国居民膳食指南》、《2015-2020年美国居民膳食指南》及目前国际上排名最前的DASH饮食模式和地中海饮食模式，个性化的计算并制定出每日饮食总热量和营养素的合理搭配方案。您只需在方案推荐的食物类别中选择喜欢吃的食物并按照方案推荐的份量进餐，就可有效改善您的健康状况。
							</div>
							<div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>每日早餐
									</div>
									<div>
										<table class="table">
											<thead>
												<th class="topic">食物类别</th>
												<th class="topic">推荐份数</th>
												<th class="topic">1份食物示例</th>
											</thead>
											<tr>
												<td class="topic">五谷根茎类</td>
												<td>
													{{form.content.breakfast.grain}}份
												</td>
												<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
												</td>
											</tr>
											<tr>
												<td class="topic">蔬菜类</td>
												<td>
													{{form.content.breakfast.vegetables}}份
												</td>
												<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
												</td>
											</tr>
											<tr>
												<td class="topic">蛋豆鱼肉类</td>
												<td>
													{{form.content.breakfast.fish}}份
												</td>
												<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
											</tr>
											<tr>
												<td class="topic">奶类</td>
												<td>
													{{form.content.breakfast.milk}}份
												</td>
												<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
											</tr>
										</table>
									</div>
								</div>
								<div class="item">
									<div class="m20 ">
										<div class="sx"></div>每日午餐
									</div>
									<div>
										<table class="table">
											<thead>
												<th class="topic">食物类别</th>
												<th class="topic">推荐份数</th>
												<th class="topic">1份食物示例</th>
											</thead>
											<tr>
												<td class="topic">五谷根茎类</td>
												<td>
													{{form.content.lunch.grain}}份
												</td>
												<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
												</td>
											</tr>
											<tr>
												<td class="topic">蔬菜类</td>
												<td>
													{{form.content.lunch.vegetables}}份
												</td>
												<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
												</td>
											</tr>
											<tr>
												<td class="topic">蛋豆鱼肉类</td>
												<td>
													{{form.content.lunch.fish}}份
												</td>
												<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
											</tr>
											<tr>
												<td class="topic">奶类</td>
												<td>
													{{form.content.lunch.milk}}份
												</td>
												<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
											</tr>
										</table>
									</div>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>每日晚餐
									</div>
									<div>
										<table class="table">
											<thead>
												<th class="topic">食物类别</th>
												<th class="topic">推荐份数</th>
												<th class="topic">1份食物示例</th>
											</thead>
											<tr>
												<td class="topic">五谷根茎类</td>
												<td>
													{{form.content.dinner.grain}}份
												</td>
												<td>米、面、粉、燕麦、杂豆1/3碗；土豆、红薯等薯类1碗；玉米1根；面包1片；馒头、窝头2寸见方（半个）；油条半根；烙饼手掌大小一块；烧饼半个；饺子、馄饨6个；拳头大小的包子半个
												</td>
											</tr>
											<tr>
												<td class="topic">蔬菜类</td>
												<td>
													{{form.content.dinner.vegetables}}份
												</td>
												<td>白菜、菠菜、芹菜、油菜、韭菜、黄瓜、茄子、西葫芦、鲜蘑菇、冬瓜、苦瓜等蔬菜500克（熟的约一盘或2碗）；白萝卜、茭白、冬笋、青椒1碗半；豆角、胡萝卜、洋葱、蒜苗1碗或半盘；鲜豆类半碗
												</td>
											</tr>
											<tr>
												<td class="topic">蛋豆鱼肉类</td>
												<td>
													{{form.content.dinner.fish}}份
												</td>
												<td>鱼100克；瘦肉50g ;五花肉25克；鸡蛋、鸭蛋1个；鹌鹑蛋6个；10公分大小虾6只</td>
											</tr>
											<tr>
												<td class="topic">奶类</td>
												<td>
													{{form.content.dinner.milk}}份
												</td>
												<td>全脂牛奶200ml；低脂牛奶250ml；酸奶100ml；奶酪、奶粉25克</td>
											</tr>
										</table>
									</div>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>每日加餐
									</div>
									<div>
										<table class="table">
											<thead>
												<th class="topic">食物类别</th>
												<th class="topic">推荐份数</th>
												<th class="topic">1份食物示例</th>
											</thead>
											<tr>
												<td class="topic">水果类</td>
												<td>
													{{form.content.add.fruits}}份
												</td>
												<td>苹果、梨、桃、橘子、橙子、杏、狝猴桃切块或葡萄粒1碗；草莓1碗半、西瓜2碗；中等大小香蕉1根；纯果汁1杯（200ml)</td>
											</tr>
											<tr>
												<td class="topic">坚果种子类</td>
												<td>
													{{form.content.add.nut}}份
												</td>
												<td>坚果种子1汤勺（15克）；核桃2个；杏仁10粒</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
							<div class="item">
								<div class="m20">
									<div class="sx"></div>健康饮食模式强调
								</div>
								<div class="desc">
									<li>
										膳食方案中推荐的五谷根茎类份量中至少应一半以上选择全谷物食物。全谷物食物是指完整、碾碎、破碎或压片的谷物种子，基本营养成分包括淀粉质胚乳、胚芽与麸皮，各组成部分的相对比例与完整果实一样。全谷物食品能够极大地增加膳食纤维、B族维生素及矿物质的营养供给，延缓血糖的上升速度，对控制血糖，预防心脑血管疾病有重要作用。
									</li>
									<li>
										尽可能选择高营养密度的食物和饮料，即能最大限度提供维生素、矿物质和其他人体所需的、对健康有益的营养素的食物，很少或几乎不添加固体脂肪或额外的糖、精炼的淀粉或钠。
									</li>
									<li>
										向食用更多蔬菜、水果的饮食模式转变；用全麦面包替换白面包、用糙米替换白米；用海产品替换肉禽蛋；用豆类或者坚果与种子的混合食物代替肉禽；用植物油替换固体脂肪；用水替换甜饮料以减少添加糖摄入；用脱/低脂奶、瘦肉替代全脂奶和肥肉以减少饱和脂肪的摄入；用香草和香料替换盐给食物调味；选择新鲜、冷冻食品替换加工肉类和家禽以减少盐的摄入。
									</li>
									<li>
										推荐成年人和年龄≥14岁的青少年每天限制钠盐摄入低于6g（患有高血压者低于5克）。
									</li>
								</div>
							</div>
						</div>
						<el-row class="dealwith">
							<el-col :span="12">
								责任医师：{{form.name}}
							</el-col>
							<el-col :span="12" class="tag_text_right">
								发布时间：{{form.time}}
							</el-col>
						</el-row>
					</div>
				</div>
				<div v-show="isShow">
					<div class="save" v-if="showSaveBtn">
						<el-button type="primary" :loading="isLoading" @click="save('form')">发 布</el-button>
					</div>
					<div class="save" v-if="!showSaveBtn">
						<el-popconfirm confirmButtonText='删除' title="确定删除处方吗？" @confirm="delPrescription">
							<el-button slot="reference" style="float: left;" type="danger" :loading="isLoading" >删除处方</el-button>
						</el-popconfirm>
						<el-button type="primary" :loading="isLoading" @click="update">修改处方</el-button>
						<el-button type="primary" :loading="isLoading" @click="dialogVisible=true" v-if="patientInfo.wxBindingState == 1">推送处方</el-button>
						<span style="opacity: 0;">{{this.prescriptionItem.hospitalFoodVO.id}}</span>
					</div>
				</div>
			</el-form>
		</template>

		<SendDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible" type="2" :prescriptionId="prescriptionItem.hospitalFoodVO.id" />

	</div>

</template>

<script>
	import api from '@/service/api.js';
	import htmlToPdf from '@/service/htmlToPdf'
	import SendDialog from './sendDialog.vue';

	export default {
		components: {
			SendDialog
		},
		props: {
			patientInfo:{
				required: true
			},
			recordId: {
				required: true,
			},
			patientId: {
				required: true
			},
			datasources: {
				// required: true
				default: null
			},
			onEvalShow: {
				type: Function,
				default: null
			},
			isShow: {
				type: Boolean,
				default: true
			},
			sideEvalList:{
				// required: true
				default: null
			},
			medicalRecordDetail:{
				// required:true
				default: null
			}
		},
		data() {
			var valiNumberPass = (rule, value, callback) => { //包含小数的数字
				let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
				if (value === '') {
					callback(new Error('请输入内容'));
				} else if (!reg.test(value)) {
					callback(new Error('请输入数字'));
				} else {
					callback();
				}
			};
			return {
				tag: true,
				hidden: false,
				prescriptionItem: {},
				form: {
					energy: "",
					structure: "",
					mild: "",
					obvious: "",
					content: {
						calorieSum: "",
						breakfast: {
							grain: "",
							milk: "",
							fish: "",
							vegetables: ""
						},
						lunch: {
							grain: "",
							milk: "",
							fish: "",
							vegetables: ""
						},
						dinner: {
							grain: "",
							milk: "",
							fish: "",
							vegetables: ""
						},
						add: {
							nut: "",
							fruits: ""
						},
						salt:"",
						oil:""

					},
					name: "",
					time: ""
				},
				showSaveBtn: true,
				isLoading: false,
				isSave: false,
				rules: {
					'content.calorieSum': [{
						required: true,
						message: '请输入每日摄入总热量',
						trigger: 'blur'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值',
						trigger: 'blur'
					}],
					'content.breakfast.grain': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.breakfast.milk': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.breakfast.fish': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.breakfast.vegetables': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.lunch.grain': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.lunch.milk': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.lunch.fish': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.lunch.vegetables': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.dinner.grain': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.dinner.milk': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.dinner.fish': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.dinner.vegetables': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.add.nut': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}],
					'content.add.fruits': [{
						required: true,
						message: '请输入推荐份数'
					}, {
						validator: valiNumberPass,
						message: '必须为数字值'
					}]
				},
				dialogVisible:false,
				showAll:false,

			}
		},
		watch:{
			'form.content':{
				handler(){
					this.dataHandle();
				},
				deep: true,
				immediate: true
			},
		},
		async created(){
			let query=this.$route.query;
			if(Number(query.datasources)!=1&&Number(query.datasources)!=2){
				let res=await api.checkPreVisibleTypes({
					recordId:this.recordId,
					type:2
				})
				this.showAll=res.data;
			}else{
				this.showAll=true
			}
		},
		methods: {
			async init(prescriptionItem) {
				this.prescriptionItem = prescriptionItem;
				if (this.prescriptionItem.hospitalFoodVO.evalResult != null) {
					let evalResult = JSON.parse(this.prescriptionItem.hospitalFoodVO.evalResult);
					
					this.tag = true;
					if (this.prescriptionItem.hospitalFoodVO.content == null) {
						this.form.energy = evalResult.level;
						this.form.structure = evalResult.other.foodStructureLevel;
						this.form.content.calorieSum = evalResult.prescription[0].calorieSum;
						this.form.content.salt = evalResult.prescription[0].salt;
						let day = evalResult.prescription[0].day;
						let every = evalResult.prescription[0].every;
						
						this.form.content.breakfast.grain = day.morning.stapleFood==null?0:day.morning.stapleFood;
						this.form.content.breakfast.milk = day.morning.milk==null?0:day.morning.milk;
						this.form.content.breakfast.fish = day.morning.eggBeanFishMeat==null?0:day.morning.eggBeanFishMeat;
						this.form.content.breakfast.vegetables = day.morning.vegetable==null?0:day.morning.vegetable;
						
						this.form.content.lunch.grain = day.lunch.stapleFood==null?0:day.lunch.stapleFood;
						this.form.content.lunch.milk = day.lunch.milk==null?0:day.lunch.milk;
						this.form.content.lunch.fish = day.lunch.eggBeanFishMeat==null?0:day.lunch.eggBeanFishMeat;
						this.form.content.lunch.vegetables = day.lunch.vegetable==null?0:day.lunch.vegetable;
						
						this.form.content.dinner.grain = day.supper.stapleFood==null?0:day.supper.stapleFood;
						this.form.content.dinner.milk = day.supper.milk==null?0:day.supper.milk;
						this.form.content.dinner.fish = day.supper.eggBeanFishMeat==null?0:day.supper.eggBeanFishMeat;
						this.form.content.dinner.vegetables = day.supper.vegetable==null?0:day.supper.vegetable;
						
						this.form.content.add.fruits = day.extraMeals.fruit==null?0:day.extraMeals.fruit;
						this.form.content.add.nut = day.extraMeals.seed==null?0:day.extraMeals.seed;
						
						this.form.content.oil = every.oil==null?0:every.oil;
						this.dataHandle();
					}
				} else {
					this.tag = false;
				}
				if (this.prescriptionItem.hospitalFoodVO.content != null) {
					this.hidden = true;
					let content = JSON.parse(this.prescriptionItem.hospitalFoodVO.content);
					if(content.result != 0 && content.result != null){
						this.tag = true;
					}
					this.form = content;

					this.showSaveBtn = false;
					this.isSave = true;
				}
				console.log(this.form,'=================ssssssssssdd',)

			},
			dataHandle(){
				this.form.content.totalCopies=parseFloat(this.form.content.breakfast.grain==''?0:this.form.content.breakfast.grain)
										+parseFloat(this.form.content.breakfast.milk==''?0:this.form.content.breakfast.milk)
										+parseFloat(this.form.content.breakfast.fish==''?0:this.form.content.breakfast.fish)
										+parseFloat(this.form.content.breakfast.vegetables==''?0:this.form.content.breakfast.vegetables)
										+parseFloat(this.form.content.lunch.grain==''?0:this.form.content.lunch.grain)
										+parseFloat(this.form.content.lunch.milk==''?0:this.form.content.lunch.milk)
										+parseFloat(this.form.content.lunch.fish==''?0:this.form.content.lunch.fish)
										+parseFloat(this.form.content.lunch.vegetables==''?0:this.form.content.lunch.vegetables)
										+parseFloat(this.form.content.dinner.grain==''?0:this.form.content.dinner.grain)
										+parseFloat(this.form.content.dinner.milk==''?0:this.form.content.dinner.milk)
										+parseFloat(this.form.content.dinner.fish==''?0:this.form.content.dinner.fish)
										+parseFloat(this.form.content.dinner.vegetables==''?0:this.form.content.dinner.vegetables)
										+parseFloat(this.form.content.add.fruits==''?0:this.form.content.add.fruits)
										+parseFloat(this.form.content.add.nut==''?0:this.form.content.add.nut)
										+parseFloat(this.form.content.oil==''?0:this.form.content.oil);
						this.form.content.calorieSum=this.form.content.totalCopies*90;

			},
			save(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.form.result = this.medicalRecordDetail.diagnosisName;
						this.isLoading = true;
						let user = JSON.parse(localStorage.getItem("user"));
						let myDate = new Date();
						let time = myDate.getFullYear() + "/" + (myDate.getMonth() + 1) + "/" + myDate
							.getDate() + " " +
							myDate.toLocaleTimeString();
						let data = [];
						data.push({
							"content": JSON.stringify({
								energy: this.form.energy,
								structure: this.form.structure,
								mild: this.form.mild,
								obvious: this.form.obvious,
								content: this.form.content,
								name: user.data.name,
								time: time
							}),
							"datasources": this.datasources,
							"patientId": this.patientId,
							"prescriptionType": 2,
							"recordId": this.recordId,
							"state": 1
						});
						let res = await api.addPrescription(data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.showSaveBtn = false;
						this.isSave = true;

						this.form = {
							energy: this.form.energy,
							structure: this.form.structure,
							mild: this.form.mild,
							obvious: this.form.obvious,
							content: this.form.content,
							name: user.data.name,
							time: time,
						}
						this.$emit('trigger-event',2)
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			update() {
				this.showSaveBtn = true;
				this.isSave = false;
				this.prescriptionItem.hospitalFoodVO.pushTime=null

			},
			exportPdf() {
				htmlToPdf.outPutPdfFn(document.querySelector("#diet-print"), "饮食处方");
			},
			isHidden() {
				this.hidden = true;
			},
			async delPrescription(){
				let res=await api.delPrescription({
					id:this.prescriptionItem.hospitalFoodVO.id,
					prescriptionType:2
				})
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.showSaveBtn = true;
				this.isSave = false;
				this.prescriptionItem.hospitalFoodVO.content = null;
				this.init(this.prescriptionItem)
				this.$emit('trigger-event',2)
			}
		}
	}
</script>


<style lang="less" scoped>
.wrap{
	min-height: 300px;
}

.exportPdf{
		float: right;
		margin-top: -18px;
		background: #fff;
		color: #699ce4;
		border-radius: 20px;
		padding: 6px 12px;
	}
	.level-low {
		color: #67C23A;
	}

	.level-middle {
		color: #E6A23C;
	}

	.level-high {
		color: #F56C6C;
	}

	.body {
		padding: 20px 120px;
		font-size: 20px;
		color: #409EFF;
	}

	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
	}


	.save {
		text-align: right;
		padding: 20px 120px;
	}

	.dealwith {
		color: #333333;
		font-size: 14px;
		padding-top: 20px;
	}

	.saveText {
		background-color: #EFF8FE;
		border-color: #409EFF;
	}

	.text {
		font-size: 20px;
		margin: 15px 0;
		color: #333333;
	}

	.tag {
		border-radius: 5px;
		height: 35px;
		margin: 0 30px;
		padding: 0 15px;
		font-size: 13px;
	}

	.h20 {
		height: 20px;
	}

	.color-grey {
		background-color: #E6E6E6;
		color: #4D4D4D;
	}

	.color-orange {
		background-color: #FFECEC;
		color: #FF5D5D;
	}

	table {
		border: 1px solid #4D4D4D;
		border-collapse: collapse;
		border-spacing: 0;
	}

	table tr {
		height: 100px;
	}

	table th {
		height: 40px;
		border: 1px solid #4D4D4D;
	}

	table td {
		padding: 10px;
		height: 20px;
		border: 1px solid #4D4D4D;
		width: 25%;
	}

	.table {
		text-align: center;
		font-size: 14px;
		color: #333333;
		width: 100%;
	}

	.tr {
		height: 100px;
	}

	.topic {
		background-color: #CFEAFC;
	}

	.sx {
		width: 5px;
		background-color: #409EFF;
		height: 22px;
		border-radius: 5px;
		float: left;
		margin-right: 10px;
		margin-top: 3px;
	}

	.el-form .el-input:not(.el-transfer-panel__filter) {
		width: 60%;
		height: 30px;
	}

	.desc {
		border-radius: 5px;
		border: 1px solid #409EFF;
		background-color: #EFF8FE;
		margin: 30px 0;
		padding: 20px 20px 20px 40px;
		font-size: 14px;
		color: #333333;
		line-height: 40px;
	}

	/deep/.el-form-item__content {
		margin-top: 18px;
	}

	/deep/.el-form-item__error {
		margin-left: 40%;
	}

	.text_dec {
		text-align: left;
		padding-left: 5px;
		line-height: 40px;
		margin-top: 18px
	}

	.know {
		color: #4D4D4D;
		cursor: pointer;
	}

	.goto {
		color: #FF5D5D;
		cursor: pointer;
	}

	.tag_text {
		line-height: 35px;
		font-size: 14px;
	}

	.tag_text_right {
		text-align: right;
	}

	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
		font-size: 20px;
	}

	.cf {
		font-size: 24px;
		text-align: center;
		color: #333333
	}

	.mTop10 {
		margin-top: 10px;
	}

	.m20 {
		margin: 20px 0;
	}



	#diet-print {
		.body {
			padding: 20px 120px;
			font-size: 18px;
			color: #409EFF;
		}

		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
		}


		.save {
			text-align: right;
			padding: 20px 120px;
		}

		.dealwith {
			color: #000;
			font-size: 16px;
			padding-top: 20px;
		}

		.saveText {
			background-color: #EFF8FE;
			border-color: #409EFF;
		}

		.text {
			font-size: 24px;
			margin: 15px 0;
			color: #000;
		}

		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 16px;
		}

		.h20 {
			height: 20px;
		}

		.color-grey {
			background-color: #E6E6E6;
			color: #4D4D4D;
		}

		.color-orange {
			background-color: #FEF8DE;
			color: #EEC211;
		}

		table {
			border: 1px solid #4D4D4D;
			border-collapse: collapse;
			border-spacing: 0;
		}

		table th {
			height: 40px;
			border: 1px solid #4D4D4D;
		}

		table td {
			padding: 10px;
			height: 20px;
			border: 1px solid #4D4D4D;
			width: 25%;
		}

		.table {
			text-align: center;
			font-size: 17px;
			color: #333333;
			width: 100%;
		}

		.topic {
			background-color: #CFEAFC;
		}

		.sx {
			width: 5px;
			background-color: #409EFF;
			height: 22px;
			border-radius: 5px;
			float: left;
			margin-right: 10px;
			margin-top: 3px;
		}

		.el-form .el-input:not(.el-transfer-panel__filter) {
			width: 60%;
			height: 30px;
		}

		.desc {
			border-radius: 5px;
			border: 1px solid #409EFF;
			background-color: #EFF8FE;
			margin: 30px 0;
			padding: 20px 20px 20px 40px;
			font-size: 18px;
			color: #000;
			line-height: 40px;
		}

		/deep/.el-form-item__content {
			margin-top: 18px;
		}

		/deep/.el-form-item__error {
			margin-left: 40%;
		}

		.text_dec {
			text-align: left;
			padding-left: 5px;
			line-height: 40px;
			margin-top: 18px
		}

		.know {
			color: #4D4D4D;
			cursor: pointer;
		}

		.goto {
			color: #EEC211;
			cursor: pointer;
		}

		.tag_text {
			line-height: 35px;
			font-size: 18px;
		}

		.tag_text_right {
			text-align: right;
		}

		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
			font-size: 26px;
		}

		.cf {
			font-size: 30px;
			text-align: center;
			color: #000
		}

		.mTop10 {
			margin-top: 10px;
		}

		.m20 {
			margin: 40px 0;
		}

	}

	.hide {
		position: absolute;
		z-index: -999;
	}
</style>
